export type RovoNavigationClickedProps = {
	source: string;
	queryHash: string;
	queryLength: number;
	searchSessionId?: string;
	isHello?: boolean;
	referrer?: string;
	experiment?: string;
	commonAttributes?: Record<string, any>;
};

export const onRovoNavigationClicked: ({
	source,
	experiment,
	commonAttributes,
	queryHash,
	queryLength,
	searchSessionId,
	isHello,
	referrer,
}: RovoNavigationClickedProps) => {
	source: string;
	eventType: 'ui';
	action: string;
	actionSubject: string;
	name: string;
	attributes: {
		commonAttributes: Record<string, any> | undefined;
		queryHash: string;
		queryLength: number;
		searchSessionId: string | undefined;
		isHello: boolean | undefined;
		referrer: string | undefined;
		additionalAttributes: {
			experiment: string | undefined;
		};
	};
} = ({
	source,
	experiment,
	commonAttributes,
	queryHash,
	queryLength,
	searchSessionId,
	isHello,
	referrer,
}: RovoNavigationClickedProps) => ({
	source,
	eventType: 'ui' as const,
	action: 'clicked',
	actionSubject: 'rovoNavigation',
	name: 'rovoNavigation',
	attributes: {
		commonAttributes,
		queryHash,
		queryLength,
		searchSessionId,
		isHello,
		referrer,
		additionalAttributes: {
			experiment,
		},
	},
});
